
//const rootUrl = "https://2o4upyp88b.execute-api.us-east-1.amazonaws.com";
const rootUrl = process.env.REACT_APP_API_URL;

const logging = false;

const isTest = false;

const testData = [
  { UserID: '1', IsDeleted: true, Color: 'red', InsertDtm: '2024-08-16T18:36:03+0000', Type: 'SUV' }
  , { IsDeleted: false, UserID: '15', Color: 'red', InsertDtm: '2024-08-16T21:07:35.671Z', Type: 'SUV' }
  , { UserID: '2', Color: 'pink', InsertDtm: '2024-08-16T20:37:06.028Z', Type: 'Car' }
  , { UserID: '3', Color: 'pink', InsertDtm: '2024-08-16T20:37:06.028Z', Type: 'Car' }
  , { UserID: '4', Color: 'pink', InsertDtm: '2024-08-16T20:37:06.028Z', Type: 'Car' }
  , { UserID: '5', Color: 'pink', InsertDtm: '2024-08-16T20:37:06.028Z', Type: 'Car' }
  , { UserID: '6', Color: 'pink', InsertDtm: '2024-08-16T20:51:31.966Z', Type: 'Car' }
  , { UserID: '7', Color: 'yellow', InsertDtm: '2024-08-16T20:51:44.780Z', Type: 'Car' }
];

export async function GetQueue(clientCode) {

  var content = { "ClientCode": clientCode };

  if (isTest) {
    //testData.UserID = String(testData.UserID);
    //testData.shift();
    //let now = new Date();
    //let isoString = now.toISOString();

    //testData.push({UserID: isoString});

    //return testData.concat([{UserID: isoString}]);
    return testData;
  }

  //const endPoint = rootUrl + "/items";
  //const endPoint = rootUrl + "/items/ABC School";
  const endPoint = rootUrl + "/items/" + clientCode;

  if (logging) console.log("Fetching queue for clientCode:", clientCode);
  if (logging) console.log("Endpoint URL:", endPoint);

  const accessToken = "";

  const headers = new Headers();
  //const bearer = `Bearer ${accessToken}`;
  //headers.append("Authorization", bearer);
  //headers.append("Access-Control-Allow-Origin","*");
  //headers.append("Access-Control-Allow-Credentials", true);
  //headers.append("Access-Control-Allow-Headers", "*");

  const options = {
    //mode: 'no-cors',
    method: "GET",
    headers: headers
    //,body: JSON.stringify(content)
  };

  return fetch(endPoint, options)
    .then(response => response.json())
    //.then(response => response.sort((a, b) => b.name.localeCompare(a.name)).json())

    //.then(response => console.log(response))
    //.then(response => console.log(response.json()))
    .catch(error => console.log(error));
}


export async function parseApiResponse(response) {
  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch {
    return { body: text, statusCode: response.status || 200 };
  }
}

/*v1
export function AddQueue(content) {

  const endPoint = rootUrl + "/items";
  const accessToken = "";

  const headers = new Headers();
  //const bearer = `Bearer ${accessToken}`;

  //headers.append("Authorization", bearer);
  //headers.append("Access-Control-Allow-Origin","*");
  //headers.append("Content-Type", "application/json");

  const options = {
    //mode: 'no-cors',
    method: "PUT",
    //body: JSON.stringify({content}),
    body: content,
    headers: headers//{"Content-Type": "application/json"}
  };

  //console.log(options);
  //console.log(content);

  fetch(endPoint, options)
    .then(res => res.statusText)
    //.then(data => console.log(data))
    .catch(err => console.log(err));
}
*/

/*v2
export async function AddQueue(payload) {
  const endPoint = rootUrl + "/items";

  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  };

  const res = await fetch(endPoint, options);
  if (!res.ok) {
    throw new Error(`Request failed: ${res.status} ${res.statusText}`);
  }
  return res;
}
*/

export async function AddQueue(payload) {
  let body;

  // Normalize: accept old string format or new object format
  if (typeof payload === "string") {
    try {
      body = JSON.parse(payload);
    } catch (err) {
      console.error("AddQueue: invalid JSON string:", payload);
      throw new Error("AddQueue received invalid JSON string");
    }
  } else if (typeof payload === "object" && payload !== null) {
    body = payload; // already an object
  } else {
    throw new Error("AddQueue received unsupported payload type");
  }

  const endPoint = rootUrl + "/items";

  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  };

  const res = await fetch(endPoint, options);
  if (!res.ok) {
    throw new Error(`Request failed: ${res.status} ${res.statusText}`);
  }

  return res;
}

//export default GetQueue;


/* GenericDbCall
sample data:
var payload = {
  "table": "clients",
  "operation": "put",
  "item": {
    "ClientCode": { "S": "ABC School" },
    "ClientDisplay": { "S": "ABC School" },
    "FirstLoginDatetime": { "S": "2025-09-02T21:23:20.457Z" },
    "ExpirationDatetime": { "S": "2025-12-31T21:23:20.457Z" },
    "StripeCustomerId": { "S": "cus_NX9vYzA1e2b3xA" },
    "IsActive": { "BOOL": true }
  }
};
*/

/*
export function GenericDbCall_oldV1(payload) {
  const apiUrl = rootUrl + "/record/update";
  const headers = new Headers();


  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      //'Content-Type': 'text/plain',
      // 'Authorization': 'Bearer YOUR_JWT_TOKEN' // if using auth
    },
    body: JSON.stringify(payload)
    //body: payload
  })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      return response.json();
    })
    .then(data => {
      if (logging) console.log('API response:', data);
      return data;
    })
    .catch(error => {
      console.error('Request failed:', error);
    });
}
*/

export function GenericDbCall(payload) {
  const apiUrl = rootUrl + "/record/update";

  if (logging) console.log("Sending payload to GenericDbCall:", payload);

  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
    .then(async response => {
      const rawText = await response.text();
      if (logging) console.log("Raw response text:", rawText);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}. Body: ${rawText}`);
      }

      try {
        const parsed = JSON.parse(rawText);
        return parsed;
      } catch (err) {
        console.warn("Response is not valid JSON. Returning raw text.");
        return rawText; // or return {} if you want to standardize
      }
    })
    .then(data => {
      if (logging) console.log('API response:', data);
      return data;
    })
    .catch(error => {
      console.error('Request failed:', error);
    });
}


export async function clearByPartitionKey({ table, partitionKeyName, partitionKeyValue, sortKeyName }) {
  const apiUrl = rootUrl + "/record/update";

  const payload = {
    table,
    operation: "clearByPartitionKey",
    partitionKeyName,
    partitionKeyValue,
    sortKeyName
  };

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    //const result = await response.json();
    //return result;
    return await parseApiResponse(response);


  } catch (error) {
    console.error("Error calling clearByPartitionKey:", error);
    return { statusCode: 500, body: "Request failed" };
  }
}


export async function deleteQueueRow({ table, itemsToDelete }) {
  const apiUrl = rootUrl + "/record/update";

  /*
  const itemsToDelete = [
    { pk: "user#123", sk: "order#456" },
    { pk: "user#789", sk: "order#111" }
  ];
  */

  const payload = {
    table,
    operation: "deleteItems",
    itemsToDelete
  };

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    //const result = await response.json();
    //return result;
    return await parseApiResponse(response);


  } catch (error) {
    console.error("Error calling deleteQueueRow:", error);
    return { statusCode: 500, body: "Request failed" };
  }
}